import _ from 'underscore';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

export const Layout = () => null;

export const LayoutContainer = ({
  children,
  template: Template,
  ...templateProps
}) => {
  const items = useRef({});
  const childrenCache = useRef({});
  const childrenArray = React.Children.toArray(children);

  _.each(childrenArray, (child) => {
    if (child.type === Layout || child.type.displayName === 'Layout' || child.type.name === 'Layout') {
      const { type, component: Component, ...rest } = child.props;
      if (!childrenCache.current[type]
        || !_.isEqual(childrenCache.current[type].component, Component)
        || !_.isEqual(childrenCache.current[type].componentProps, rest)) {
        childrenCache.current[type] = {
          component: Component,
          componentProps: rest,
        };
        items.current[type] = props => <Component {...rest} >{props.children}</Component>;
      }
    }
  });

  return <Template items={items.current} {...templateProps} />;
};

LayoutContainer.propTypes = {
  template: PropTypes.func.isRequired,
  children: PropTypes.node,
};

LayoutContainer.defaultProps = {
  children: null,
};
